'use client';

var textLightColor = "#12151A";
var textDarkColor = "#ffffff";
var surfaceLightColor = "#F6F8FB";
var surfaceDarkColor = "#282D37";
var borderLightColor = "#282d378a";
var borderDarkColor = "#eef0f580";
var neutralLightColor = "#EEF0F5";
var neutralDarkColor = "#383F4D";
var colorTheme = { action: { primary: { lightest: "var(--c5-25-0_2lwccm0)", light: "var(--c5-25-0_2lwccm1)", base: "var(--c5-25-0_2lwccm2)", dark: "var(--c5-25-0_2lwccm3)", darkest: "var(--c5-25-0_2lwccm4)", safeOnLight: "var(--c5-25-0_2lwccm5)", safeOnDark: "var(--c5-25-0_2lwccm6)" } }, onAction: { primary: { lightest: "var(--c5-25-0_2lwccm7)", light: "var(--c5-25-0_2lwccm8)", base: "var(--c5-25-0_2lwccm9)", dark: "var(--c5-25-0_2lwccma)", darkest: "var(--c5-25-0_2lwccmb)", safeOnLight: "var(--c5-25-0_2lwccmc)", safeOnDark: "var(--c5-25-0_2lwccmd)" } }, onLight: { border: { actionPrimaryFallback: "var(--c5-25-0_2lwccme)" } }, onDark: { border: { actionPrimaryFallback: "var(--c5-25-0_2lwccmf)" } } };
export {
  borderDarkColor,
  borderLightColor,
  colorTheme,
  neutralDarkColor,
  neutralLightColor,
  surfaceDarkColor,
  surfaceLightColor,
  textDarkColor,
  textLightColor
};
